import React from "react";
import { arrayOf, object, shape, string } from "prop-types";
import { connect } from "react-redux";

import { Link } from "react-router-dom";

import ResourceFolder from "../components/ResourceFolder/ResourceFolder";

const ResourceFolderContainer = () => {
  const DEFAULT_CTA_NAME = "Open";
  const folderDetails = [
    {
      title: "HRGO",
      description:
        "This section contains essential information, important for our HRGO candidates.",
      link: "/profile/edit/resources/HR_GO",
      cta: DEFAULT_CTA_NAME,
      imgSrc: "https://fakeimg.pl/640x360/",
    },
    {
      title: "Assignment forms",
      description:
        "When instructed by your HRGO consultant, please download, read and complete the required documents.",
      link: "/profile/edit/resources/Assignment_Forms",
      cta: DEFAULT_CTA_NAME,
      imgSrc: "https://fakeimg.pl/640x360/",
    },
    {
      title: "Labour exploitation & modern slavery",
      description: "We need your help to reduce exploitation and slavery.",
      link: "/profile/edit/resources/Labour_Exploitation_and_Modern_Slavery",
      cta: DEFAULT_CTA_NAME,
      imgSrc: "https://fakeimg.pl/640x360/",
    },
    {
      title: "Templates",
      description: "Helpful templates to assist with your job application.",
      link: "/profile/edit/resources/Templates",
      cta: DEFAULT_CTA_NAME,
      imgSrc: "https://fakeimg.pl/640x360/",
    },
    {
      title: "Mind e-booklets",
      description:
        "These booklets provide you with advice, help and assistance covering a range of different subjects.",
      link: "/profile/edit/resources/Mind_E-Booklets",
      cta: DEFAULT_CTA_NAME,
      imgSrc: "https://fakeimg.pl/640x360/",
    },
  ];

  const mapFolderToResourceComps = () =>
    folderDetails.map((obj) => (
      <ResourceFolder
        title={obj.title}
        description={obj.description}
        link={obj.link}
        cta={obj.cta}
        imgSrc={obj.imgSrc}
        key={obj.title}
      />
    ));

  return (
    <div
      className="row justify-content-center"
      style={{ minHeight: "60vh", backgroundColor: "white" }}
    >
      <div className="col-sm-9 col-lg-8 p-2">
        <h2 className="section-header">My resources</h2>
        <p className="mb-2">
          Below are some materials that you might find useful throughout your
          search for employment and when in a role.
        </p>
        {mapFolderToResourceComps()}
        <div className="d-flex justify-content-end">
          <Link
            style={{ minWidth: "175px" }}
            to="/profile"
            className="btn btn-outline-dark text-dark col-12 col-sm-3 col-lg-2 my-2 hover-text-white"
          >
            Back to My Account
          </Link>
        </div>
      </div>
    </div>
  );
};

ResourceFolderContainer.propTypes = {
  resources: arrayOf(
    shape({
      title: string.isRequired,
      description: string.isRequired,
      link: string,
      cta: string,
    })
  ),
  appData: object.isRequired,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const mapDispatchToProps = {};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(ResourceFolderContainer);
